import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import {
  type ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "../ui/chart";
import type { WeekTotals } from "./metrics";

const flowConfig = {
  created: { label: "Created", color: "var(--chart-1)" },
  completed: { label: "Completed", color: "var(--chart-2)" },
  openAtEnd: { label: "Open at end", color: "var(--chart-4)" },
} satisfies ChartConfig;

export function CreatedVsCompletedChart({ totals }: { totals: WeekTotals[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Created vs completed</CardTitle>
        <CardDescription>Issue flow per week, with the open backlog at each week's end</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={flowConfig} className="aspect-auto h-64 w-full">
          <BarChart data={totals} margin={{ left: -20, right: 4 }}>
            <CartesianGrid vertical={false} />
            <XAxis dataKey="week" tickLine={false} axisLine={false} tickMargin={8} />
            <YAxis allowDecimals={false} tickLine={false} axisLine={false} width={40} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <ChartLegend content={<ChartLegendContent />} />
            <Bar dataKey="created" fill="var(--color-created)" radius={[3, 3, 0, 0]} />
            <Bar dataKey="completed" fill="var(--color-completed)" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
